import type { Dispatch } from 'react';
import { createContext } from 'react';
import type { ICareProviderAddRightsState } from '../../../interfaces/careProviderAddRightsState';
import type { AddRightsAction } from './careProviderAddRightsReducer';
import { emptyValidationErrors } from '../../../../utils/validation';
import { AddRightsSteps, ChooseRightsSteps } from '../../../interfaces/careProviderAddRightsState';

export const CareProviderAddRightsContext = createContext<{
    addRightsState: ICareProviderAddRightsState;
    dispatchAddRightsAction: Dispatch<AddRightsAction>;
}>({
    addRightsState: {
        currentStep: AddRightsSteps.addRights,
        chooseRightsStep: ChooseRightsSteps.chooseRight,
        consumerServices: [],
        providerServices: [],
        supervisorServices: [],
        serviceOrganizationSettings: [],
        errors: emptyValidationErrors,
        serviceEmploymentActivities: [],
    },
    dispatchAddRightsAction: () => null,
});
